Vue.asyncComponent('ak-drawer', {
    data: () => {
        return {
            q: null,
            pinned: false,
        }
    },
    props: {
        showDrawer: {
            type: Boolean,
            required: false,
            default: ''
        }
    },
    model: {
        prop: 'showDrawer',
        event: 'close'
    },
    methods: {
        togglePinned() {
            this.pinned = !this.pinned;

            // We set the current pinned state as a cookie
            // So when the user logs back in the drawer is in the same state
            localStorage.setItem('ak-drawer-pinned', this.pinned);

            // Notify the parent component that the menu is pinned
            this.$emit('togglePinned', this.pinned);
        },
        close() {
            if ( ! this.pinned) {
                this.$emit('close', false);
            }
        },
        checkPinnedStatus() {
            this.pinned = localStorage.getItem('ak-drawer-pinned') === 'true';
            this.$emit('togglePinned', this.pinned);
        },
        setScrollPosition() {
            localStorage.setItem('drawer-scroll-top', this.$refs.drawer.scrollTop);
        },
        setScrollPositionFromStorage() {
            if(localStorage.getItem('drawer-scroll-top')) {
                setTimeout(() => {
                    this.$refs.drawer.scrollTop = parseFloat(localStorage.getItem('drawer-scroll-top'));
                }, 200)
            }
        }
    },
    updated () {
        this.setScrollPositionFromStorage();
    },
    mounted() {
        this.checkPinnedStatus();
        this.setScrollPositionFromStorage();
    }
}, 'wrappers/ak-drawer.html');